import { CalculatedFees } from '@/apis/payments/requests'
import { Button } from '@/app/common/components/Button'
import { PurseAllocationForm } from '@/app/common/components/purse_allocation_form/purse_allocation_form'
import { PurseAllocationSummary } from '@/app/common/components/purse_allocation_form/purse_allocation_summary'
import usePurseAllocationForm from '@/app/common/components/purse_allocation_form/usePurseAllocationForm'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout'
import { PursesArray } from '@/schemas/provider.schema'
import { SelectedPurse } from '@/storage/applications/providerPaySlice'
import { useTranslation } from 'react-i18next'

interface Props {
  apiPurses: PursesArray
  onNext: (selectedPurses: SelectedPurse[]) => void
  defaultValues: SelectedPurse[]
  amount: number
  fees: CalculatedFees
}

function SelectPursesForm(props: Props) {
  const { apiPurses, onNext, defaultValues, amount, fees } = props
  const { t } = useTranslation()

  const { getSelectedPurses, methods, totalApplicantAmount } =
    usePurseAllocationForm({
      apiPurses: apiPurses,
      baseAmount: amount,
      serviceFee: fees.service_fee,
      serviceFeePayer: fees.serviceFeePayer,
      totalAmount: amount,
      selectedPurses: defaultValues,
    })

  function onSubmit() {
    const selectedPurses = getSelectedPurses()
    onNext(selectedPurses)
  }

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header className="mb-8">
        {t('choose_which_purse_will_fund_the_reimbursement')}
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className="w-full">
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div className="space-y-4 w-full">
            <PurseAllocationForm
              apiPurses={apiPurses}
              methods={methods}
              paymentAmount={totalApplicantAmount}
              paymentType="Reimbursement"
            />
            <PurseAllocationSummary
              total={totalApplicantAmount}
              selectedPurses={getSelectedPurses()}
            />

            <Button className="w-full">{t('continue')}</Button>
          </div>
        </form>
      </FamilyWizardLayout.Content>
    </FamilyWizardLayout>
  )
}

export default SelectPursesForm
